import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '../../utils/analytics';

// Component that tracks page views automatically
const PageViewTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view when location changes
    analytics.trackPageView(location.pathname);
  }, [location]);
  
  return null; // This component doesn't render anything
};

export default PageViewTracker;